/** A count with its noun, plural unless the count is 1: "1 task", "3 tasks". Regular plurals only. */
export const pluralise = (count: number, noun: string): string =>
  `${count} ${noun}${count === 1 ? '' : 's'}`;
